export const PORTFOLIO_PAGE_VISIT = 'Portfolio Page Visit';
export const PAGE_SOURCE_QUERY = 'pageSource';
export const YES = 'Yes';
export const NO = 'No';
export const ENTRY_POINT = 'sourceBPUrl';
export const GOOGLE_AUTH = 'accounts.google.com';
export const AUTH_URL = '/auth';
export const DEFAULT_CATEGORY_COUNT = 3;
export const WEBVIEW_CAN_GO_BACK = 'canWebviewGoBack';
